import { useMemo } from 'react';
import { CrudListPage, type DataTableV2Column } from '@core/components';
import { useCrudList } from '@core/hooks/useCrudList';
import {
  type LegacyCollar,
  deleteLegacyCollar,
  getAllLegacyCollars,
  reorderLegacyCollars,
} from '../../../api/legacyCollar';
import LegacyCollarDialog from '../../components/LegacyCollarDialog';
import { useAppContext } from '../../context/AppContext';
import { filterCollarsByFlag } from '../../utils/collar';

const loadAlbCollars = async () =>
  filterCollarsByFlag(await getAllLegacyCollars(), 'isAlb');

const AlbCollars = () => {
  const { refreshContext } = useAppContext();
  const {
    items: collars,
    loading,
    dialogOpen,
    editingItem: editingCollar,
    deleteConfirm,
    load: loadCollars,
    openCreate,
    closeDialog,
    cancelDelete,
    confirmDelete,
    getRowId,
    contextMenuItems,
    rowReorder,
  } = useCrudList<LegacyCollar>({
    loadItems: loadAlbCollars,
    deleteItem: (collar) => deleteLegacyCollar(collar.id),
    reorderItems: reorderLegacyCollars,
    loadErrorMessage: 'Failed to load collars',
    deleteSuccessMessage: 'Collar deleted',
    deleteErrorMessage: 'Failed to delete collar',
    reorderErrorMessage: 'Failed to reorder collars',
    refreshContext,
  });

  const columns = useMemo<DataTableV2Column<LegacyCollar>[]>(
    () => [
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        minWidth: 180,
      },
    ],
    []
  );

  return (
    <CrudListPage<LegacyCollar>
      variant="section"
      title="Alb Collars"
      rows={collars}
      columns={columns}
      loading={loading}
      getRowId={getRowId}
      contextMenuItems={contextMenuItems}
      rowReorder={rowReorder}
      addConfig={{ label: 'Add Collar', onAdd: openCreate }}
      addEditDialog={
        <LegacyCollarDialog
          open={dialogOpen}
          onClose={closeDialog}
          collar={editingCollar}
          onSuccess={() => loadCollars()}
        />
      }
      deleteConfig={{
        title: 'Delete collar',
        item: deleteConfirm,
        getContent: (collar) =>
          `Are you sure you want to delete "${collar.name}"?`,
        onConfirm: confirmDelete,
        onCancel: cancelDelete,
      }}
    />
  );
};

export default AlbCollars;
